import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUserRoles } from '../auth/cookieUtils';

const PrivateRoute = ({ children, allowedRoles }) => {
  const authenticated = isAuthenticated();
  const userRoles = getUserRoles();

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.some((role) => userRoles.includes(role))) {
    return <Navigate to="/dashboard" replace />; // Redirect to dashboard if roles don't match
  }

  return children;
};

export default PrivateRoute;